export default /* glsl */`
mat3 rotationMat(float aRad) {
    float cosA = cos(aRad);
    float sinA = sin(aRad);
    return mat3(
        cosA, -sinA, 0.0,
        sinA, cosA, 0.0,
        0.0, 0.0, 1.0
    );
}

vec3 mixLinearGradientColors(vec3 color0, vec3 color1, float ratio0, float ratio1, float radians, vec2 coord, vec2 resolution, bool fixChubb)
{
    float size = max(resolution.x, resolution.y);
    vec3 sizesVec = vec3(size, size, 1.0);

    vec3 transformedFragCoord = vec3(coord - 0.5 * resolution, 0.0) / sizesVec;
    transformedFragCoord = rotationMat(radians) * transformedFragCoord;
    transformedFragCoord += vec3(0.5);

    float gradientRatio = transformedFragCoord.y;

    // Noise to overcome Chubb illusion
    if (fixChubb == true) {
        float grainRatio = 2000.;
        highp float rand = noise(transformedFragCoord.xy * grainRatio);
        gradientRatio += 0.05 * rand;
    }

    highp vec3 color = color0;

    if (ratio1 > 0.0 && gradientRatio > ratio0) {
        if (gradientRatio > ratio1) {
            color = color1;
        } else {
            color = smoothmixvec3(color, color1, ratio0, ratio1, gradientRatio);
        }
    }

    return color;
}
`;
